import React from 'react';
import { usePermissions } from '@hooks/usePermissions';

import {
  CustomersOverview,
  FyndAIEventsOverview,
  GoodfyndSitesOverview,
  NumOrdersOverview,
  PopularProductsOverview,
  TotalSalesOverview,
  VendorPreOrderingOverview,
} from '../cards';
import VendorPayoutOverview from '../cards/VendorPayoutOverview';

import { StyledContainer } from './styles';

export default function OverviewCardsContainer() {
  const { isManager } = usePermissions();
  return (
    <StyledContainer>
      {isManager && (
        <>
          <TotalSalesOverview />
          <NumOrdersOverview />
        </>
      )}

      {isManager && (
        <>
          <VendorPayoutOverview />
        </>
      )}

      <VendorPreOrderingOverview />

      {isManager && (
        <>
          <CustomersOverview />
        </>
      )}

      <PopularProductsOverview />

      <GoodfyndSitesOverview />

      <FyndAIEventsOverview />
    </StyledContainer>
  );
}
